import comp from "./CopyToOtherStudentsModal";
export default comp;
